import { Link } from "react-router-dom";
import { ISdColDef } from "../../baseColumn/BaseColumnTypes";
import { BaseTextColumnBuilder } from "../../baseColumn/BaseTextColumn_builder";
import { NAME_COLUMN_CONFIG } from "./NameColumn_config";
import ModalContext from "../../../../../../modalZ/context/ModalContext";

interface INameColumnBuilder {}

export class NameColumnBuilder extends BaseTextColumnBuilder implements INameColumnBuilder {
  constructor(columnOptions?: ISdColDef<any, any>) {
    super({ ...NAME_COLUMN_CONFIG(), ...columnOptions });
  }

  withLinkCell = (urlCb: (id: number | string) => string) => {
    this.setColumnOptions({
      cellRenderer: params => {
        const itemId = params.data.id;
        const mainUrl = urlCb(itemId);
        return (
          <Link key={itemId} to={`${mainUrl}`} onClick={() => ModalContext.hide()}>
            <span className="hover-link">{params.data.name}</span>
          </Link>
        );
      }
    });
    return this;
  };
}
